// assets/recently-viewed.js
(function(){
  // 1️⃣ Record current product handle
  const currentHandle = window.location.pathname
    .split('/products/').pop()
    .replace(/\/.*/,'');
  let viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');

  // remove duplicates & stick this handle at front
  viewed = viewed.filter(h => h !== currentHandle);
  viewed.unshift(currentHandle);

  // keep only last 5
  if (viewed.length > 5) viewed = viewed.slice(0,5);
  localStorage.setItem('recentlyViewed', JSON.stringify(viewed));

  // 2️⃣ Render the rest (skip the first = current product)
  const container = document.getElementById('RecentlyViewedProducts');
  if (!container) return;

  // grab currency from Liquid data-attribute
  const currency = window.Shopify?.currency?.active || 'USD';
  // formatter for symbol + number
  const symbolFormatter = new Intl.NumberFormat(navigator.language, {
  style: 'currency',
  currency: 'USD', // Force just '$' without CA/AU prefix
  currencyDisplay: 'symbol'
});

  viewed.slice(1).forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(product => {
        const rawPrice  = product.variants[0].price / 100;
        const symbolPrice   = symbolFormatter.format(rawPrice);
        // append the code after the symbol+number
        const priceWithCode = `${symbolPrice} ${currency}`;

        const card = document.createElement('div');
        card.className = 'recent-item grid__item';
        card.innerHTML = `
          <a href="${product.url}" class="card-wrapper">
            <img src="${product.images[0]}" alt="${product.title}" class="recent-item__img"/>
            <div class="recent-item__info">
              <p class="recent-item__title">${product.title}</p>
              <p class="recent-item__price">${priceWithCode}</p>
            </div>
          </a>`;
        container.appendChild(card);
      });
  });
})();
